import styled from 'styled-components'

export const SiteLayoutContent = styled.div`
  min-height: 280px;
  background: #fff;
  height: 100vh;
  iframe{
    width: 100%;
    height: 100vh;
  }
}
`

export const ContainerImage = styled.div`
  /* margin-right: auto; */
  margin-left: 10%;
  width: fit-content;
  align-self: stretch;
  display: flex;
  align-items: center;
  img{
    height: 60px;
    width: auto;
    max-width: 220px;
    object-fit: contain;
    display: block;
  }
  span{
    margin-left: 20px;
    font-size: 0.8rem;
    font-weight: 700;
  }
`

interface IframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  title: string; // Aqui adicionamos 'title' como uma propriedade obrigatória
}

export const Iframe = styled.iframe<IframeProps>`
  width: 100%;
  height: 100vh;
`;

export const HideBar = styled.div`
  z-index: 1000;
  height: 60px;
  transform: translateY(-54px);
  background-color: white;
`
export const MenuContainer = styled.div`
  width: fit-content;
  span{
    font-size: 0.8rem;
    font-weight: 700;
  }
`
export const ContainerWord = styled.div`
  margin-right: auto;
  margin-left: auto;
  width: fit-content;
  font-weight: 700;
  font-size: 24px;

`
